import { useMemo } from 'react';

import { ABTestingConfig, abTestingFunction } from '@/helpers/abTesting';
import { useServer } from '@/modules/server/context/ServerEnvContext';
import { useCommonStore } from '@/store';

export function useABTesting<T extends object>(
  experiment: string,
  config: ABTestingConfig<T>
): string | React.ComponentType<T> | null {
  const { cmsABTests, isMobileDevice, countryCode } = useServer();
  const user = useCommonStore.use.user();

  const availableForTesting = useMemo(
    () =>
      abTestingFunction(
        experiment,
        config,
        user,
        countryCode,
        cmsABTests,
        isMobileDevice
      ),
    [experiment, config, user, countryCode, cmsABTests, isMobileDevice]
  );

  return availableForTesting;
}
